import { render, staticRenderFns } from "./ResearchGroup.html?vue&type=template&id=41e97c58&scoped=true&"
import script from "./ResearchGroup.vue?vue&type=script&lang=js&"
export * from "./ResearchGroup.vue?vue&type=script&lang=js&"
import style0 from "./ResearchGroup.scss?vue&type=style&index=0&id=41e97c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e97c58",
  null
  
)

export default component.exports